import { addDays, format as dateFnsFormat, subDays } from "date-fns";
import { formatDate } from "../../../../../helpers/date.js";
/* Enable all the days starting from min date */ const getAllDays = (disabledDays)=>[
        ...Array(365)
    ].reduce((acc, _curr, ind)=>{
        const date = dateFnsFormat(addDays(new Date(), ind), 'yyyy-MM-dd');
        if (!disabledDays.find((element)=>element === date)) acc.push(date);
        return acc;
    }, []);
/* Build enabled days excluding disabled days*/ export function buildEnableDates(props, disableDates) {
    const { value , checkIn , checkOut , enableAllDays =false , mode  } = props;
    const lengthValue = value?.length ?? 0;
    /* No operative or no checkOut operative*/ if (enableAllDays) {
        return getAllDays(disableDates);
    }
    /* CheckIn operative */ if (!!(checkIn?.length && lengthValue !== 1) || checkIn?.length && mode === 'single') return checkIn;
    /* CheckOut operative */ if (lengthValue === 1 && checkOut?.length) return checkOut.reduce((acc, curr)=>{
        const currDate = new Date(curr);
        if (!disableDates.find((item)=>curr === item || currDate < new Date(item))) acc.push(curr);
        return acc;
    }, []);
    return getAllDays(disableDates);
}
/* Find disabled days by the prop releaseDays */ export function buildDisableDates(props) {
    const { value , disabledDates , releaseDays =0 , disablePrevDays =false  } = props;
    const finalDisableDates = disabledDates ?? [];
    if (!value?.length) return finalDisableDates;
    if (value.length === 1 && releaseDays > 0) {
        for(let i = 0; i < releaseDays; i++){
            finalDisableDates.push(dateFnsFormat(addDays(value[0], i), 'yyyy-MM-dd'));
            if (i !== 0) finalDisableDates.push(dateFnsFormat(subDays(value[0], i), 'yyyy-MM-dd'));
        }
    }
    if (disablePrevDays && !releaseDays) {
        const dateSelected = new Date(value[0]);
        const dateDiff = new Date().getTime() - dateSelected.getTime();
        //Transform miliseconds to Days
        const diffDays = -Math.floor(dateDiff / (1000 * 60 * 60 * 24));
        for(let i = 0; i < diffDays; i++){
            if (i !== 0) finalDisableDates.push(dateFnsFormat(subDays(value[0], i), 'yyyy-MM-dd'));
        }
    }
    return finalDisableDates;
}
export async function calendarFormatData(date, format = 'yyyy-LL-dd', language = 'es') {
    return await formatDate(date, format, language?.toLowerCase()).then((finalDate)=>finalDate.split(' ').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' '));
}

//# sourceMappingURL=index.js.map